import React from "react";
import PropTypes from "prop-types";
import I18N from "../../I18N";
import { TestBox, CheckResult } from "../index";
import "./liveStatus.scss";

const LiveStatus = ({ liveStatus, handleReTest }) => {
  const buttonRef = React.createRef();
  const { status, isLoading, error } = liveStatus;
  return (
    <TestBox
      testName={I18N.t("LIVE_STATUS")}
      handleReTest={handleReTest}
      buttonRef={buttonRef}
      isLoading={isLoading}
      error={error}
    >
      {status ? (
        <div>
          <p>{status}</p>
          <CheckResult isSuccess={status === "RUNNING"} />
        </div>
      ) : (
        <div className="live-status__button-wrapper">
          <button
            onClick={() => {
              if (buttonRef && buttonRef.current) {
                buttonRef.current.click();
              }
            }}
            className="live-status__start-test-button"
          >
            {I18N.t("TEST_LIVE")}
          </button>
        </div>
      )}
    </TestBox>
  );
};

LiveStatus.propTypes = {
  liveStatus: PropTypes.object.isRequired,
  handleReTest: PropTypes.func.isRequired
};

export default LiveStatus;
